import React from "react";
import Breadcrumb from "./Elements/Breadcrumb";
import GenerationDetails from "./GenerationDetails";
import ShowcaseSection from "./ShowcaseSection";

const SingleSOPExample = (data: any) => {
  if (!data?.data) return <div>Loading...</div>;

  data = data.data[0];
  return (
    <div className="relative max-w-7xl mx-auto mt-10 grid px-4">
      <div className="py-10">
        <Breadcrumb pageTitle={data?.title} />
        <h1 className="text-3xl font-bold sm:text-5xl text-warm-gray-900 ">
          {data?.title}
        </h1>
        {/* <p className="mt-4 max-w-4xl text-xl text-slate-500 line-clamp-3">
          {data.description}
        </p> */}

        {data?.tags?.map((tag: any, key: any) => (
          <span
            key={key}
            className="inline-flex items-center rounded-md mt-8 mr-4 bg-primary-100 px-2.5 py-0.5 font-semibold text-primary-500"
          >
            {tag}
          </span>
        ))}
      </div>
      <GenerationDetails
        className="relative md:-left-5 md:ml-auto px-4 md:px-0"
        name={data?.username}
        time={data?._createdAt}
      />
      {data?.Sections?.map((section: any) => (
        <ShowcaseSection key={section._key} id={section._ref} />
      ))}
    </div>
  );
};

export default SingleSOPExample;
